<template>
  <div id="AdminCancelation">

    <b-container fluid>
      <b-row class="mb-1 text-left">
        <b-col >
          <h1 class="labelBold">{{ this.$t(`bookingTransport.AdminCancelation`) }} </h1>
        </b-col>
      </b-row>

      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">

        <b-col sm="6">
          <label class="black">{{ $t("bookingTransport.CancelationRoundTrip") }}</label>
          <vue-timepicker v-model="Schedule.RoundTrip" ></vue-timepicker>
          <div v-if="$v.Schedule.RoundTrip.$error" class="error-msg">
            <p v-if="!$v.Schedule.RoundTrip.required">{{$t("bookingTransport.CancelationRoundTrip")}}{{$t("bookingTransport.required")}}</p>
          </div>
        </b-col>
        <b-col sm="6">
          <label class="black">{{ $t("bookingTransport.CancelationReturnTrip") }}</label>
          <vue-timepicker v-model="Schedule.ReturnTrip" ></vue-timepicker>
          <div v-if="$v.Schedule.ReturnTrip.$error" class="error-msg">
            <p v-if="!$v.Schedule.ReturnTrip.required">{{$t("bookingTransport.CancelationReturnTrip")}}{{$t("bookingTransport.required")}}</p>
          </div>
        </b-col>

      </b-row>
      <br/>
      <b-row cols="2" cols-sm="4" cols-md="6" cols-lg="12">

        <b-col sm="5" lg="5"  style="background-color:white;">
          <div class="">
            <label class="labelBold mt-2">
              {{ $t("bookingTransport.AnticipationDays")}}
            </label>
            <input type="number" v-model="AnticipationDays"/>
            <div v-if="$v.AnticipationDays.$error" class="error-msg">
              <p v-if="!$v.AnticipationDays.required">{{$t("bookingTransport.AnticipationDays")}}{{$t("bookingTransport.required")}}</p>
            </div>
          </div>
        </b-col>
        <b-col  sm="2" lg="2" >

        </b-col>

        <b-col  sm="5" lg="5" >
          <button class="btn-confirm btn-outline-secondary" @click="Upload()">{{ $t("bookingTransport.Save") }}</button>
        </b-col>
      </b-row>



    </b-container>
  </div>
</template>

<script>

const ids = (value) => value > 0;
// import GoogleMapsApiLoader from 'google-maps-api-loader'
import { required, url, decimal } from "vuelidate/lib/validators";

import API_SERVICE from "@/lib/api/Booking.js";
import store from '@/vuex/store';

import "vue2-timepicker/dist/VueTimepicker.css";
import VueTimepicker from "vue2-timepicker";

const api = new API_SERVICE();


import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {

  components: {
    store,
    VueTimepicker
  },

  data() {
    return {
      Schedule:{
        RoundTrip:'',
        ReturnTrip:''
      },
      AnticipationDays:'',
      id:''

    };
  },
  validations: {
    Schedule: {
      RoundTrip:{
        required
      },
      ReturnTrip:{
        required
      }
    },
    AnticipationDays:{
      ids
    }
  },
//computed:{
// },
  beforeMount: async function() {


    await this.getSet();


  },

  methods:{

    Upload: async function(){

      this.$store.commit("global/SET_LOADING", true);
      try {
        const queries = {
          id: this.id,
          cancellation_round_trip: this.Schedule.RoundTrip,
          type_cancellation_return_trip: this.Schedule.ReturnTrip,
          anticipation_days: this.AnticipationDays};

        // La primera vez que se crea en la tabla setting se utiuliza lo siguiente
        //const resp = await api.Createsettings(queries);

        const resp = await api.PUTsettings(queries);



        if(resp.data.message == "Datos actualizados correctamente."){
          this.$store.commit("global/SET_LOADING", false);
          this.getSet();
          this.$store.commit("global/SET_ALERT", {
            msg: resp.data.message,
            show: true,
            type: "success"
          });


        }else
        {
          this.$store.commit("global/SET_LOADING", false);
          this.$store.commit("global/SET_ALERT", {
            msg: resp.data.message,
            show: true,
            type: "error"
          });
        }
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    },



    getSet: async function() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.GETsettings();
        var Setting = resp.data;

        this.Schedule.RoundTrip = Setting.data[0].cancellation_round_trip;
        this.Schedule.ReturnTrip = Setting.data[0].type_cancellation_return_trip;
        this.AnticipationDays = Setting.data[0].anticipation_days;
        this.id = Setting.data[0].id;

        this.$store.commit("global/SET_LOADING", false);
      }
      catch(error){
        this.$store.commit("global/SET_LOADING", false);
        this.$store.commit("global/SET_ALERT", {
          msg: error,
          show: true,
          type: "error"
        });
      }
    }

  }
}


</script>

<style lang="scss">
#AdminCancelation {
  background-color: $white;
  padding: 2rem 4rem;
}
.error-msg {
  color: $warn_red;
  font-size: 14px;
}

.btn-confirm {
  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
}
</style>
